.wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  flex-shrink: 0;
  user-select: none;
  pointer-events: none;
  clip-path: circle(50% at center);
}

.avatarVideo {
  --row: 0;
  --col: 0;
  --frame-size: 0;

  width: 100%;
  height: 100%;
  flex-shrink: 0;
  transform: scale(1.2);
  background-size: 2000%;
  background-repeat: no-repeat;
  background-position: calc(-1 * var(--frame-size) * var(--col)) calc(-1 * var(--frame-size) * var(--row));

  position: relative;
  z-index: 1;
}
